import { DATE_VALUES } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_DETECTED_BY_FILTER,
  SORTING_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    data: {
      results: [],
    },
    page: 1,
    search: '',
    loader: false,
    message: null,
    error: null,
    generalFilter: 0,
    dateFilter: DATE_VALUES.DAYS_BACK_90,
    detectedByFilter: null,
    // null = "no explicit sort" -> the epic omits sortingBy and the endpoint
    // keeps its legacy reverse-based -mitigation_date order.
    sortingBy: null,
    sortingDirection: 'desc',
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return { ...state, page: 1, loader: true }
      case SEARCH_RESET:
        return { ...state, search: '' }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
          error: null,
        }
      case GENERAL_FILTER_CHANGE:
        return {
          ...state,
          generalFilter: action.payload.value,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, message: null }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          data: {
            results: [],
          },
        }
      case DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
          sortingBy: null,
          sortingDirection: 'desc',
        }

      case DATE_FILTER_CHANGE:
        return { ...state, dateFilter: action.payload.value, loader: true }
      case SET_DETECTED_BY_FILTER:
        return {
          ...state,
          detectedByFilter: action.payload.values,
        }
      case SORTING_CHANGE:
        return {
          ...state,
          sortingBy: action.payload.sortingBy,
          sortingDirection: action.payload.sortingDirection,
          page: 1,
          loader: true,
        }
      default:
        return state
    }
  }
}
